import { static_options } from './options';

const mode_multiple = {
  mode: 'multiple',
  optionLabelProp: 'children',
  filterOption: (input: any, option: any) => {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
};

export const seeding_modifying_list: Array<any> = [
  { tag_name: 'a-select', key: 'charge_teacher_id', label: '负责班主任', value: undefined, bind: { allowClear: true, placeholder: '请选择' }, options: [] },
  {
    tag_name: 'a-cascader',
    key: 'tag',
    label: '标签',
    value: undefined,
    bind: { options: [], fieldNames: { label: 'tag_name', value: 'id', children: 'parent' }, changeOnSelect: true, placeholder: '请选择' }
  },
  { tag_name: 'a-select', key: 'type_id', label: '创商跟进分类', value: undefined, bind: { placeholder: '请选择' }, options: [] },
  { tag_name: 'a-input', key: 'followup', label: '创商跟进记录', value: undefined, bind: { placeholder: '请输入' } },
  { tag_name: 'a-input', key: 'user_log', label: '班主任备注', value: undefined, bind: { placeholder: '请输入' } }
];

export const recruition_modifying_list: any = {
  charger_id: { tag_name: 'a-select', key: 'charger_id', label: '转化负责人', value: undefined, bind: { allowClear: true, placeholder: '请选择', mode: 'multiple' }, options: [] },
  status: {
    tag_name: 'a-select',
    key: 'status',
    label: '项目跟进状态',
    value: undefined,
    bind: { allowClear: true, placeholder: '请选择', mode: 'multiple' },
    options: static_options.status
  },
  source: {
    tag_name: 'a-select',
    key: 'source',
    label: '来源',
    value: undefined,
    bind: { allowClear: true, placeholder: '请选择', mode: 'multiple' },
    options: static_options.source
  },
  source_desc: { tag_name: 'a-input', key: 'source_desc', label: '来源说明', value: undefined, bind: { placeholder: '请输入' } },
  target_periods: { tag_name: 'a-input', key: 'target_periods', label: '目标期数', value: undefined, bind: { placeholder: '请输入' } },
  interviewer: { tag_name: 'a-input', key: 'interviewer', label: '面试官', value: undefined, bind: { placeholder: '请输入' } },
  fee_channel: {
    tag_name: 'a-select',
    key: 'fee_channel',
    label: '缴费渠道',
    value: undefined,
    bind: { allowClear: true, placeholder: '请选择' },
    options: static_options.fee_channel
  },
  followup: { tag_name: 'a-input', key: 'followup', label: '创商跟进记录', value: undefined, bind: { placeholder: '请输入' } }
};

export const delivery_modifying_list: any = {
  undelivered_module: {
    tag_name: 'a-select',
    key: 'undelivered_module',
    label: '未交付模块',
    value: [],
    bind: { allowClear: true, placeholder: '请选择', ...mode_multiple },
    options: static_options.undelivered_module
  },
  teacher_id: { tag_name: 'a-select', key: 'teacher_id', label: '创商班主任', value: [], bind: { allowClear: true, placeholder: '请选择', ...mode_multiple }, options: [] },
  class_period: { tag_name: 'a-input', key: 'class_period', label: '班期', value: undefined, bind: { allowClear: true, placeholder: '请选择' } },
  gender: { tag_name: 'a-select', key: 'gender', label: '性别', value: undefined, bind: { placeholder: '请输入' }, options: static_options.gender },
  solution_progress: { tag_name: 'a-input', key: 'solution_progress', label: '交付方案进展', value: undefined, bind: { placeholder: '请输入' } }
};
